<script>
import EnvironmentUtils from '@/utils/environmentUtils'
import Checkbox from '@/components/Checkbox'
import Button from '@/components/Button'

export default
{
    name: 'notification-settings',

    created ()
    {
    },

    render () 
    {
        return (
            <div id='notification-settings-view'>
                <div class='section' v-show={this.hasRequirements}>
                    <div class='title'>Général</div>
                    <checkbox label='Être notifié des alertes importantes' v-model={this.$store.state.user.tags.notifiedOnImportantAlert}
                        on-click={this.saveTags} />
                    <checkbox label='Être notifié des communications' v-model={this.$store.state.user.tags.notifiedOnCommunication}
                        on-click={this.saveTags} />
                    <checkbox label='Être notifié des nouvelles actualités' v-model={this.$store.state.user.tags.notifiedOnNewActuality}
                        on-click={this.saveTags} />
                    <checkbox label='Être notifié des nouveaux événements' v-model={this.$store.state.user.tags.notifiedOnNewEvent}
                        on-click={this.saveTags} />
                    <checkbox v-show={EnvironmentUtils.cityFeatures.hasLostObjects} label='Être notifié des nouveaux objets perdus publiés'
                        v-model={this.$store.state.user.tags.notifiedOnNewPublishedLostObject}
                            on-click={this.saveTags} />
                    <checkbox v-show={EnvironmentUtils.cityFeatures.hasLostPets} label='Être notifié des nouveaux animaux perdus publiés'
                        v-model={this.$store.state.user.tags.notifiedOnNewPublishedLostPet}
                            on-click={this.saveTags} />
                    <checkbox v-show={EnvironmentUtils.cityFeatures.hasStores} label='Recevoir les communications de mes commerces'
                        v-model={this.$store.state.user.tags.notifiedOnStoreCommunication} on-click={this.saveTags} />
                </div>
                <div v-show={this.userPrivileges.isAdministrator && this.hasRequirements} class='section admin'>
                    <div class='title'>Administrateur</div>
                    <div class='notification-setup' v-show={this.userPrivileges.canManageReports}>
                        <div class='name'>Signalements</div>
                        <div class='options'>
                            <checkbox label='Notification' icon={require('@/assets/img/bell.svg')} v-model={this.$store.state.user.tags.notifiedOnNewReport}
                                on-click={this.saveTags} />
                            <checkbox label='Courriel' icon={require('@/assets/img/at.svg')} v-model={this.$store.state.user.settings.mailedOnNewReport}
                                on-click={this.saveSettings} />
                        </div>
                    </div>
                    <div class='notification-setup' v-show={this.userPrivileges.canManageLostObjects}>
                        <div class='name'>Objets perdus</div>
                        <div class='options'>
                            <checkbox label='Notification' icon={require('@/assets/img/bell.svg')} v-model={this.$store.state.user.tags.notifiedOnNewLostObject}
                                on-click={this.saveTags} />
                            <checkbox label='Courriel' icon={require('@/assets/img/at.svg')} v-model={this.$store.state.user.settings.mailedOnNewLostObject}
                                on-click={this.saveSettings} />
                        </div>
                    </div>
                    <div class='notification-setup' v-show={this.userPrivileges.canManageLostPets}>
                        <div class='name'>Animaux perdus</div>
                        <div class='options'>
                            <checkbox label='Notification' icon={require('@/assets/img/bell.svg')} v-model={this.$store.state.user.tags.notifiedOnNewLostPet}
                                on-click={this.saveTags} />
                            <checkbox label='Courriel' icon={require('@/assets/img/at.svg')} v-model={this.$store.state.user.settings.mailedOnNewLostPet}
                                on-click={this.saveSettings} />
                        </div>
                    </div>
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            isWebPushEnabled: false,
        }
    },

    computed:
    {
        userPrivileges ()
        {
            const accountId = this.$store.state.user.accountId
            const userPrivileges = this.$store.getters.cities.getAccountPrivileges({ cityId: EnvironmentUtils.cityId, accountId })

            return userPrivileges
        },

        hasRequirements ()
        {
            return true

            return cordova.platformId == 'browser'
                ? this.isWebPushEnabled
                : true
        }
    },

    watch:
    {
    },

    mounted ()
    {

    },

    methods:
    {
        saveTags ()
        {
            this.$store.commit('user/saveTags')
        },

        saveSettings ()
        {
            this.$store.commit('user/saveSettings')
        }
    },

    components:
    {
        Checkbox,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#notification-settings-view
{
    padding: 14px 1px 16px 1px;

    .checkbox
    {
        margin-top: 7px;
    }

    & .notification-setup
    {
        & .name
        {
            margin-top: 10px;
        }

        & .options
        {
            display: flex;
            flex-direction: row;

            & .checkbox
            {
                padding: 13px;
                padding-right: 18px;

                &:not(:last-of-type)
                {
                    margin-right: 10px;
                }

                & .check-icon
                {
                    display: none;
                }
            }
        }
    }

    & .section
    {
        &:not(:first-of-type)
        {
            margin-top: 20px;
        }

        &.admin
        {
        }

        & .title
        {
            font-weight: 700;
            font-size: 23px;
            margin-bottom: 10px;
        }

        & .description
        {
            margin-bottom: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/NotificationSettings.vue